import React, { useEffect, useMemo, useState } from "react";
import * as S from "./EndStatusChange.style";
import * as P from "../../../../../../../utils/pipes";
import { useTranslation } from "react-i18next";
import ZaiaInput from "../../../../../../zaiaComponents/zaiaInput";
import FlorenzTextArea from "../../../../../../florenzComponents/florenzTextArea";
import FlorenzInputDate from "../../../../../../florenzComponents/florenzInputDate";

function EndStatusChange({ 
  processStagesData,
  currentStatus,
  newCurrenStatusData,
  statusDescription,
  setStatusDescription,
  statusDate,
  setStatusDate,
  frequency,
  counterStage,
  setCounterStage,
  newCounterStage,
  setNewCounterStage
}) {

  const {t, i18n: { language }} = useTranslation("global");

  const displayValue = useMemo(() => {
    return statusDescription && statusDescription.toString();
  }, [statusDescription]);

  const handleKeyUp = (e, msg) => {
    if(e.target.scrollHeight !== 100) {
      e.target.style.height = 'inherit';
      e.target.style.height = `${e.target.scrollHeight}px`; 
    }
    if(msg === ""){
      e.target.style.height = '100px';
    }
  }

  console.log(
    "que faço de todo", newCurrenStatusData
  );
  

  return (
    <S.EndStatusChange>
      <div className="status-changed">
        <div className="status-changed__item">
          <div className="status-changed__info">
            <div className="status-changed__label">
              <i className="status-changed__label-icon icon zaia-i-routine-activity"></i>
              <div className="status-changed__label-text">{t("changeOfStatus.oldStatus")}</div>
            </div>
            <div className="status-changed__status-name">
              {
                P.dataTranslation(processStagesData.process[0].processStages.find((item) => item.id === currentStatus)?.stageName, language)
                + ` ${processStagesData.process[0].processStages.find((item) => item.id === currentStatus)?.incremental ? counterStage : ""}`
              }
            </div> 
          </div>
          <div className="status-changed__tooltip-info">
            <i className="status-changed__tooltip-info-icon icon zaia-i-info"></i>
          </div>
        </div>
        <i className="status-changed__tooltip-icon icon zaia-i-next-1 status-changed__tooltip-icon--new">
        </i>
        <div className="status-changed__item">
          <div className="status-changed__info">
            <div className="status-changed__label">
              <i className="status-changed__label-icon icon zaia-i-new-record status-changed__label-icon--new"></i>
              <div className="status-changed__label-text status-changed__label-text--new">{t("changeOfStatus.currentStatus")}</div>
            </div>
            <div className="status-changed__status-name status-changed__status-name--new">
              {
                P.dataTranslation(newCurrenStatusData?.stageName, language)
                + ` ${newCurrenStatusData?.incremental ? newCounterStage : ""}`
              }
            </div>
          </div>
          <div className="status-changed__tooltip-info">
            <i className="status-changed__tooltip-info-icon icon zaia-i-info"></i>
          </div>
        </div>
      </div>
      <div className="status-data">
        <div className="status-info">
          <i className="status-info__icon icon zaia-i-info"></i>
          <div className="status-info__text">
            <b>{
              P.dataTranslation(newCurrenStatusData?.stageName, language)
            }:</b> {t("changeOfStatus.statusDescription1")} <b>{t("changeOfStatus.statusDescription2")} {frequency(newCurrenStatusData)}
            :</b> {t("changeOfStatus.statusDescription3")}
          </div>
        </div>
        <div className="status-field">
          <div className="status-field__label">
            <div className="status-field__text">
              {t("changeOfStatus.statusDescription")} 
            </div>
            {
              displayValue
              ? <i className="status-field__icon icon zaia-i-check-1"></i>
              : <div className="status-field__required error">*</div>
            }
          </div>
          <div className="status-field__input">
            <FlorenzTextArea
              value={statusDescription}
              getText={(e) => setStatusDescription(e)}
              onKeyUp={(e) => handleKeyUp(e, displayValue)}
            />
          </div>
        </div>
        <div className="status-field">
          <div className="status-field__input">
            <FlorenzInputDate
              label={t("changeOfStatus.statusDate")}
              value={statusDate}
              getText={(e) => setStatusDate(e)}
              type="date"
              required
            />
          </div>
        </div>
      </div>
    </S.EndStatusChange>
  );
}

export default EndStatusChange;
